/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import './status';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "message": {
                    "nested": {
                      "DeleteDeviceProfileV2Request": {
                        "fields": {
                          "deviceProfileToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "DeleteDeviceProfileV2Response": {
                        "fields": {
                          "status": {
                            "type": ".squareup.devicesettings.profiles.v2.message.Status",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.DeleteDeviceProfileV2Request && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.DeleteDeviceProfileV2Response) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DeleteDeviceProfileV2Request @ squareup/devicesettings/profiles/v2/message/delete_device_profile.proto at 11:1
 */
export const DeleteDeviceProfileV2Request = $root.lookupType('squareup.devicesettings.profiles.v2.message.DeleteDeviceProfileV2Request');
fixType(DeleteDeviceProfileV2Request, {
  deviceProfileToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DeleteDeviceProfileV2Request);
/**
 * SOURCE DeleteDeviceProfileV2Response @ squareup/devicesettings/profiles/v2/message/delete_device_profile.proto at 15:1
 */
export const DeleteDeviceProfileV2Response = $root.lookupType('squareup.devicesettings.profiles.v2.message.DeleteDeviceProfileV2Response');
fixType(DeleteDeviceProfileV2Response);
Builder.createAndAttachToType(DeleteDeviceProfileV2Response);